import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_SESSION':
      return action.session
    default:
      return state
  }
}

export default reducer
